(function () {
  const root = document.querySelector("[data-ryhp]");

  if (!root) return;

  const storageKey = root.dataset.storageKey || "resona-yuki-home-popup-dismissed-until";
  const designMode = typeof window.Shopify !== "undefined" && window.Shopify.designMode;
  const closeTriggers = root.querySelectorAll("[data-ryhp-close]");
  const cta = root.querySelector("[data-ryhp-cta]");
  const notice = root.querySelector("[data-ryhp-notice]");
  const skipToday = root.querySelector("[data-ryhp-skip-today]");
  const closeButton = root.querySelector(".ryhp__close");

  const endOfDay = () => {
    const now = new Date();
    now.setHours(23, 59, 59, 999);
    return now.getTime();
  };

  const rememberDismissal = () => {
    if (!skipToday || !skipToday.checked) return;

    try {
      window.localStorage.setItem(storageKey, String(endOfDay()));
    } catch (error) {
      return;
    }
  };

  const shouldStayHidden = () => {
    if (designMode) return false;

    try {
      const saved = Number(window.localStorage.getItem(storageKey) || 0);
      return saved > Date.now();
    } catch (error) {
      return false;
    }
  };

  const closePopup = () => {
    rememberDismissal();
    root.classList.remove("is-open");
    root.setAttribute("aria-hidden", "true");
    document.body.classList.remove("ryhp-lock");

    window.setTimeout(function () {
      root.hidden = true;
    }, 280);
  };

  const handleEscape = (event) => {
    if (event.key !== "Escape") return;
    closePopup();
  };

  if (shouldStayHidden()) {
    root.remove();
    return;
  }

  root.hidden = false;

  window.requestAnimationFrame(function () {
    root.classList.add("is-open");
    root.setAttribute("aria-hidden", "false");
    document.body.classList.add("ryhp-lock");
    if (closeButton) closeButton.focus({ preventScroll: true });
  });

  closeTriggers.forEach(function (trigger) {
    trigger.addEventListener("click", function () {
      closePopup();
    });
  });

  if (cta) {
    cta.addEventListener("click", function () {
      rememberDismissal();
    });
  }

  if (notice) {
    notice.addEventListener("click", function () {
      rememberDismissal();
    });
  }

  document.addEventListener("keydown", handleEscape);
})();
